import React, { Component } from 'react';
import 'antd/dist/antd.css';
import '../../globalcss.css';
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';
import { Row, Col, Button, Icon, Form, Input, Select } from 'antd';
import * as Action from '../../redux/action';
import { bindActionCreators } from 'redux';
import 'react-loading-bar/dist/index.css'
const FormItem = Form.Item;
const Option = Select.Option;

class Useraccount extends Component {
    state = {
        loading: false,
        visible: false
    }

    constructor(props) {
        super(props);
        this.state = {
            eventlist: [],
            userId: sessionStorage.getItem('id') ? sessionStorage.getItem('id') : localStorage.getItem('id'),
            edit_style: { display: 'block' },
            disableassign: true,
            submit: { display: 'none' },
            hidden: true,
            disableField: true
        }
    }

    componentDidMount() {
        console.log('++++++++++++++++component will mount++++++++++++++++', this.props.loggeduserDetails);
        this.props.actions.userdetails();
        if (this.props.loggeduserDetails.name) {
            this.setFormValues(this.props);

        }
        /** GET PROFILE DATA FROM PROPS*/
        if (this.props.loggeduserDetails) {
            this.setState({ userDetails: this.props.loggeduserDetails });
        }

        // function to scrollto top
        // aradhana

        window.scrollTo(0, 0)
    }

    componentWillReceiveProps(newprops) {
        if (!Object.is(newprops.loggeduserDetails, this.props.loggeduserDetails)) {
            console.log()
            this.setState({ loggeduserDetails: newprops.loggeduserDetails });
            this.setFormValues(newprops);
        }
    }

    setFormValues = (props) => {
        if (props.loggeduserDetails.name) {
            this.props.form.setFieldsValue({
                ['name']: props.loggeduserDetails.name,
                ['type']: props.loggeduserDetails.type,
                ['email']: props.loggeduserDetails.email,
                ['phoneNumber']: props.loggeduserDetails.phoneNumber,
                ['address']: props.loggeduserDetails.address,
                ['zipcode']: props.loggeduserDetails.zipcode,
                ['bussinessName']: props.loggeduserDetails.bussinessName
            })
        }
    }

    // changes after click on edit
    handleChange = (e) => {
        this.setState({ hidden: false })
        this.setState({ disableField: false });
    }
    // back to profile 
    backtopage = (e) => {
        this.setState({ hidden: true })
        this.setState({ disableField: true });
    }


    // ADD PROJECT FUNCTION 
    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.props.location);
        this.props.form.validateFields((err, values) => {
            if (!err) {

                this.setState({ show: false });
                console.log('Received values of form: ', values);

                if (this.props.loggeduserDetails) {
                    console.log(this.props.location.data);
                    console.log('edit function')

                    let data = {
                        type: values.type,
                        address: values.address,
                        name: values.name,
                        zipcode: values.zipcode,
                        bussinessName: values.bussinessName
                    }
                    console.log(data)
                    this.props.actions.updateUser(data, this.props.history)  //UPDATE(EDIT) PROFILE
                }
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="contactsec">
                {/* Profile card ui start */}

                <p className="profilehead"> {!this.state.hidden ? 'Profile Edit' : 'Profile'}<a> {this.state.hidden && <span className="float-right" onClick={this.handleChange}><Icon type="edit" /></span>}</a></p>

                <div className="profileview">

                    {/* user profile form start */}
                    <Form onSubmit={this.handleSubmit}>
                        <Row type="flex">

                            <Col lg={{ span: 17 }} xs={{ span: 24 }}>

                                <FormItem className="emailcont" label="Name">
                                    {getFieldDecorator('name', {
                                        rules: [{ required: false, message: 'Please enter name!' }]
                                    })(
                                        <Input placeholder="Name" autoComplete="Off" disabled={this.state.disableField} />
                                    )}
                                </FormItem>

                                <FormItem className="emailcont" label="Select Type">
                                    {getFieldDecorator('type', {
                                        rules: [{ required: false, message: 'Please enter type!' }]
                                    })(
                                        <Select
                                            placeholder="Type"
                                            autoComplete="off"
                                            disabled={this.state.disableField}
                                        >
                                            <Option value="Individual">Individual</Option>
                                        </Select>
                                    )}
                                </FormItem>

                                <FormItem className="emailcont" label="Email">
                                    {getFieldDecorator('email', {
                                        rules: [{ required: false, message: 'Please enter email!' }]
                                    })(
                                        <Input type="email" placeholder="email" autoComplete="Off" disabled={this.state.disableassign} />
                                    )}
                                </FormItem>

                                <FormItem className="emailcont" label="Phone No.">
                                    {getFieldDecorator('phoneNumber', {
                                        rules: [{ required: false, message: 'Please enter Phone Number!' }]
                                    })(
                                        <Input type="Number" placeholder="Phone Number" disabled={this.state.disableassign} />
                                    )}
                                </FormItem>

                                <FormItem className="emailcont" label="Address">
                                    {getFieldDecorator('address', {
                                        rules: [{ required: false, message: 'Please enter address!' }]
                                    })(
                                        <Input placeholder="address" autoComplete="Off" disabled={this.state.disableField} />
                                    )}
                                </FormItem>

                                <FormItem className="emailcont" label="Zipcode">
                                    {getFieldDecorator('zipcode', {
                                        rules: [{ required: false, message: 'Please enter zipcode!' }]
                                    })(
                                        <Input placeholder="zipcode" autoComplete="Off" disabled={this.state.disableField} />
                                    )}
                                </FormItem>

                                {/* input for only business type */}
                                {this.props.loggeduserDetails.type == "business" &&
                                    <FormItem className="emailcont" label="Business Name">
                                        {getFieldDecorator('bussinessName', {
                                            rules: [{ required: false, message: 'Please enter bussinessName!' }]
                                        })(
                                            <Input placeholder="bussinessName" autoComplete="Off" disabled={this.state.disableField} />
                                        )}
                                    </FormItem>
                                }

                                {/* submit and cancel btn variation start */}
                                <div>
                                    <FormItem className="text-left m0 inline-block" >
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            hidden={this.state.hidden}
                                            onClick={this.backtopage}
                                            className="probtn inline-block">
                                            Submit
                                        <NavLink to="../profile/Useraccount"></NavLink>
                                        </Button>
                                    </FormItem>
                                    <FormItem className="text-left m0 inline-block" >
                                        <Button
                                            type="primary"
                                            hidden={this.state.hidden}
                                            onClick={this.backtopage}
                                            className="probtn ml15">
                                            Cancel
                                        <NavLink to="../profile/Useraccount"></NavLink>
                                        </Button>
                                    </FormItem>

                                </div>
                                {/* submit and cancel btn variation start */}
                            </Col>
                        </Row>
                    </Form>
                    {/* user profile form start */}
                </div>
                {/* Profile card us end */}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    console.log('Profile  screen info', state)
    return state

}

function mapDispatchToProps(dispatch, state) {
    return ({
        actions: bindActionCreators(Action, dispatch)
    })
}
const WrappedNormalLoginForm = Form.create()(Useraccount);
export default connect(mapStateToProps, mapDispatchToProps)(WrappedNormalLoginForm);


// WEBPACK FOOTER //
// ./src/Component/Useraccount/Useraccount.js